/**
 * @generated SignedSource<<ea37b6956d7e7d4e6bb73b9874355ab5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionNumberSetValueMutation$variables = {
  employeeId?: string | null;
  id: string;
  value: number;
};
export type TaskExecutionNumberSetValueMutation$data = {
  readonly setTaskExecutionNumber: {
    readonly formattedNumberValue: string | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly numberValue: number | null;
    readonly occasion: {
      readonly id: string;
      readonly isCompleted: boolean | null;
      readonly sum: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionNumberComponent_TaskExecutionNumber">;
  };
};
export type TaskExecutionNumberSetValueMutation = {
  response: TaskExecutionNumberSetValueMutation$data;
  variables: TaskExecutionNumberSetValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedNumberValue",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskNumberOccasion",
  "kind": "LinkedField",
  "name": "occasion",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sum",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskExecutionNumberSetValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionNumber",
        "kind": "LinkedField",
        "name": "setTaskExecutionNumber",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskExecutionNumberComponent_TaskExecutionNumber"
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TaskExecutionNumberSetValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionNumber",
        "kind": "LinkedField",
        "name": "setTaskExecutionNumber",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskNumber",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c6ba9106bd7b1dc06af8500bd18ffbaf",
    "id": null,
    "metadata": {},
    "name": "TaskExecutionNumberSetValueMutation",
    "operationKind": "mutation",
    "text": "mutation TaskExecutionNumberSetValueMutation(\n  $id: ID!\n  $value: Float!\n  $employeeId: ID\n) {\n  setTaskExecutionNumber(id: $id, value: $value, employeeId: $employeeId) {\n    id\n    ...TaskExecutionNumberComponent_TaskExecutionNumber\n    numberValue\n    formattedNumberValue\n    isCompleted\n    occasion {\n      id\n      sum\n      isCompleted\n    }\n  }\n}\n\nfragment TaskExecutionNumberComponent_TaskExecutionNumber on TaskExecutionNumber {\n  id\n  task {\n    id\n    unit\n  }\n  numberValue\n}\n"
  }
};
})();

(node as any).hash = "6e4581ae1bcd355c82061cc062844061";

export default node;
